import { UtensilsCrossed, PlugZap, Rocket } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const steps = [
  { icon: UtensilsCrossed, num: "01", title: "Bring your pots & pans", copy: "No fit-out, no contractors, no months of waiting. Your station is already built and shining." },
  { icon: PlugZap, num: "02", title: "Plug into our kitchen", copy: "Licensed, compliant, gas-and-power-ready space with cold storage, prep zones and hygiene stations." },
  { icon: Rocket, num: "03", title: "Start cooking & selling", copy: "Go live on Talabat, Deliveroo and Noon across our Dubai catchment from the very first service." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 md:py-32" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="mb-16 text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.34em] text-gold" data-testid="how-it-works-eyebrow">How It Works</p>
          <h2 className="mt-4 font-serif text-4xl font-medium tracking-tight text-white md:text-5xl" data-testid="how-it-works-heading">
            Three steps to <span className="italic text-gold">your first order</span>
          </h2>
        </Reveal>
        <div className="relative grid gap-12 md:grid-cols-3 md:gap-8">
          <div className="gold-line absolute left-0 right-0 top-10 hidden h-px md:block" aria-hidden="true" />
          {steps.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.15} className="relative text-center">
              <div className="relative mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-gold/40 bg-[#0a0a08]" data-testid={`step-icon-${s.num}`}>
                <s.icon size={28} strokeWidth={1.4} className="text-gold" />
                <span className="absolute -right-2 -top-2 rounded-full bg-gold px-2 py-0.5 font-serif text-xs font-bold text-black">{s.num}</span>
              </div>
              <h3 className="mt-7 font-serif text-2xl font-medium text-white">{s.title}</h3>
              <p className="mx-auto mt-3 max-w-xs text-sm font-light leading-relaxed text-white/60">{s.copy}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
